export default "__VITE_ASSET__BJEnHksn__"